import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEnvelope,
  faPhone,
  faClock,
  faMoneyBillAlt,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faAngleDoubleUp,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faAngleDoubleDown,
  faArrowLeft,
  faArrowRight,
  faCheck,
  faTimes,
  faSpinner,
  faHourglassStart,
  faSortDown,
  faUser,
  faPencilAlt,
  faWallet,
  faStar,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vSelect from "vue-select";
import ZurueckButton from "./Zurueck-button"
import AvatarDummy from "./AvatarDummy"
import Overlay from "./Overlay"


export default {
  /**
   * Registriert und Konfigureirt alle globalen Komponenten
   * @param {VueInstance} vueInstance
   */
  setup: (vueInstance) => {
    library.add(
      faEnvelope,
      faPhone,
      faClock,
      faMoneyBillAlt,
      faAngleUp,
      faAngleRight,
      faAngleLeft,
      faAngleDown,
      faAngleDoubleUp,
      faAngleDoubleRight,
      faAngleDoubleLeft,
      faAngleDoubleDown,
      faArrowLeft,
      faArrowRight,
      faCheck,
      faTimes,
      faSpinner,
      faHourglassStart,
      faSortDown,
      faUser,
      faPencilAlt,
      faWallet,
      faStar,
      faPlus
    );

    vueInstance.component("font-awesome-icon", FontAwesomeIcon);
    vueInstance.component("v-select", vSelect);
    vueInstance.component("zurueck-button", ZurueckButton);
    vueInstance.component("avatar-dummy", AvatarDummy);
    // eslint-disable-next-line
    vueInstance.component("overlay", Overlay);
  }
}
